import React from 'react';
import { Icon } from '@weezevent/nacre';
// eslint-disable-next-line import/no-named-as-default
import clsx from 'clsx';
import classes from './BuildingIcon.module.scss';
import PropTypes from 'prop-types';

export const BuildingIcon = ({ className }) => {
    return (
        <div className={clsx(classes.wrapper, className)}>
            <Icon margin={false} className={classes.icon} name="building" size="huge" />
        </div>
    );
};

BuildingIcon.propTypes = {
    className: PropTypes.string
};
